import type React from "react";
import type { PropsWithChildren } from "react";

import { Box } from "@similarweb/ui-components/foundations";

import { ErrorBoundaryWithLogging } from "app/pages/sales-intelligence/common-components/ErrorBoundaryWithLogging";
import { ContactWidgetDataProvider } from "app/pages/sales-intelligence/modules/ai-agent/context/ContactWidgetDataContext";
import { useSuperAgentContactsFlowStrategy } from "app/pages/sales-intelligence/modules/ai-agent/sub-modules/super-agent/hooks/useSuperAgentContactsFlowStrategy";
import { AIAgentMainErrorView } from "app/pages/sales-intelligence/pages/ai-agent/components/AIAgentMainErrorView/AIAgentMainErrorView";
import { AISuperAgentPageContent } from "app/pages/sales-intelligence/pages/ai-agent/containers/AISuperAgentPageContent";
import { ContactsFlowProvider } from "app/pages/sales-intelligence/sub-modules/contacts-search/context/ContactsFlowContext";
import { useContactsStatusEffect } from "app/pages/sales-intelligence/sub-modules/contacts-search/hooks/useContactsStatusEffect";
import { useAllCrmStatusesCall } from "app/pages/sales-intelligence/sub-modules/management/hooks/useAllCrmStatusesCall";

// Mounted under ContactWidgetDataProvider so the strategy hook can read widget data from context.
const SuperAgentContactsFlowBridge = ({ children }: PropsWithChildren) => {
    const strategy = useSuperAgentContactsFlowStrategy();
    return <ContactsFlowProvider value={strategy}>{children}</ContactsFlowProvider>;
};

export const AISuperAgentPageContainer: React.FC = () => {
    useAllCrmStatusesCall();
    useContactsStatusEffect();

    return (
        <ErrorBoundaryWithLogging
            FallbackComponent={(props) => (
                <Box
                    margin="0 0 0 189px"
                    height="100%"
                >
                    <AIAgentMainErrorView {...props} />
                </Box>
            )}
        >
            <ContactWidgetDataProvider>
                <SuperAgentContactsFlowBridge>
                    <AISuperAgentPageContent />
                </SuperAgentContactsFlowBridge>
            </ContactWidgetDataProvider>
        </ErrorBoundaryWithLogging>
    );
};
